<template>
  <div class="popSearch">
    <!-- input框 -->
    <div class="parent">
      <div type="text"
           class="ginput"
           @click="openPop">
        <template v-if="disValue">{{disValue}}</template>
        <span v-else
              class="ph">{{placeholder}}</span>
      </div>
      <i class="iconfont icon-xia"
         @click="openPop"></i>
    </div>
    <!-- pop弹出层 -->
    <mt-popup v-model="popupVisible"
              position="right">
      <!-- 黑色头部插件 -->
      <div class="topsHeader">
        <mt-header :title="title"
                   fixed
                   :style="{backgroundColor:bgcolor}">
          <i class="mintui mintui-back"
             @click="leftBack()"
             slot="left"></i>
        </mt-header>
      </div>
      <!-- 弹出层内容（搜索和列表） -->
      <div class="autoSearch">
        <div class="autoSearchTop">
          <div class="searchBox">
            <mt-search v-model="value"
                       :placeholder="searchPlaceholder"
                       @input="input()"
                       :cancel-text="$t('cancel')"></mt-search>

            <div class="autocomplete transition"
                 v-show="showList">
              <div style="width:100%;margin:0 auto;padding:0 5%;height:1.2rem;line-height:1.2rem;border-bottom:1px solid #eee"
                   v-if="type!='mem'">{{$t('pop_search_isGroup')}}：
                <div style="float:right;padding-top:0.1rem">
                  <mt-switch @change="input()"
                             v-model="isGroup"></mt-switch>
                </div>
              </div>
              <ul>
                <li v-for="(data,index) in json"
                    transition="showAll"
                    class="listBox"
                    :key="index">
                  <a href="#"
                     @click.prevent="selectList(data)">
                    <div class="detail"
                         v-if='data.cardNo'>
                      <div class="top clearfix"><p class="left">{{$t('pop_search_cardNo')}}：{{data[anchor]}}</p>
                        <p style="float: right;margin-right: 8%;">{{data.name}}</p></div>
                      <div class="ct clearfix">
                        <ul style="overflow:hidden">
                          <li class="info"
                              style="width:100%">
                            {{$t('pop_search_mobile')}}：{{data.mobile}}
                          </li>
                          <li class="info"
                              style="width:100%">
                            {{$t('pop_search_idNo')}}：{{data.idNo}} （{{data.idTypeDis}}）
                          </li>
                          <li class="info">
                            {{$t('pop_search_cardType')}}：{{data. cardType}}
                          </li>
                          <li class="info">
                            {{$t('pop_search_rateCode')}}：{{data. rateCode}}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="detail"
                         v-else
                         style="width: 97%;">
                      <div class="top clearfix"><p class="left">{{index+1}}、{{data[anchor]}}</p>
                        <p style="float: right;"> {{$t('pop_search_No')}}：{{data.id}}</p></div>
                      <div class="ct clearfix">
                        <ul style="overflow:hidden">
                          <!-- <li class="info">
                              编号：{{data.id}}
                          </li> -->
                          <li class="info">
                            {{$t('pop_search_rateCode')}}：{{data.rateCode}}
                          </li>
                          <li class="info">
                            {{$t('pop_search_src')}}：{{data.src}}
                          </li>
                          <li class="info">
                            {{$t('pop_search_market')}}：{{data.market}}
                          </li>
                          <li class="info">
                            {{$t('pop_search_cms')}}：{{data.cms_code}}
                          </li>
                          <li class="info">
                            {{$t('pop_search_saleman')}}：{{data.salemanDis}}
                          </li>
                        </ul>
                      </div>
                    </div>
                  </a>
                  <i class="iconfont icon-you"
                     style="top:1.8rem"></i>
                </li>
                <nothing :condition="json == null ||json.length == 0"
                         :dis="json==null?$t('pop_search_searchTile'):$t('nothing')"></nothing>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import {
    Popup
  } from "mint-ui";
  import nothing from "../common/nothing";

  export default {
    data() {
      return {
        popupVisible: false,
        disValue: "",
        value: "",
        showList: true,
        isGroup: false,
        json: null,
        debounceTask: 500,
        placeholder: '',
        searchPlaceholder: '',
        title: ''
      };
    },
    props: {
      name: String,
      //JSON数据取值的Key
      anchor: {
        type: String,
        required: true
      },
      type: String,
      //这是黑色头部的prop
      back: {
        default: true
      },

      searchNow: {
        default: true
      },
      bgcolor: {
        default: "#393C41"
      }
    },
    mounted() {
      if (this.type == "mem") {
        this.placeholder = this.$t('pop_search_mem_placeHolder');
        this.searchPlaceholder = this.$t('pop_search_mem_SearchplaceHolder');
      } else if (this.type == "A") {
        this.placeholder = this.$t('pop_search_A_placeHolder');
        this.searchPlaceholder = this.$t('pop_search_A_SearchplaceHolder');
      } else if (this.type == "C") {
        this.placeholder = this.$t('pop_search_C_placeHolder');
        this.searchPlaceholder = this.$t('pop_search_C_SearchplaceHolder');
      } else if (this.type == "S") {
        this.placeholder = this.$t('pop_search_S_placeHolder');
        this.searchPlaceholder = this.$t('pop_search_S_SearchplaceHolder');
      }
      this.title = this.placeholder;
    },
    methods: {
      //打开popup弹框
      openPop() {
        this.popupVisible = !this.popupVisible;
        if (this.searchNow) {
          if (!this.json) {
            this.getData();
          }
        }
      },
      //选中列表中的哪一项
      selectList(data) {
        this.disValue = data[this.anchor];
        this.popupVisible = false;
        this.$emit("onSelect", data);
      },
      setInValue(v) {
        this.disValue = v;
        this.value = v;
      },
      searchData() {
        if (this.type == "mem") {
          this.getMember(this.value);
        } else {
          this.getData(this.value);
        }
      },
      /*协议公司/旅行社/中介searchText*/
      async getData(value) {
        var url = ''
        var param = {
          pageSize: 100,
          searchText: value,
          isHotel: !this.isGroup,
          // sysCat: this.type
        }
        if(this.$logo == 'hotelGo.png'){ // 曹丹，具体问肖哥，和王万鹏
          url = '/mobilepmsapi/reception/compnaySearchNew'
          param.type = this.type
        } else {
          url = '/mobilepmsapi/reception/compnaySearch'
          param.sysCat = this.type
        }
        await this.$http.post(url, param)
          .then(res => {
            if (res.data.result == 0) {
              this.json = res.data.retVal;
            }
          });
      },
      /*获取会员信息 searchText*/
      getMember(value) {
        if (value == null || value == "") {
          this.json = null;
          return;
        }
        this.$http
          .post("/mobilepmsapi/reception/memberSearch", {
            con: value
          })
          .then(res => {
            if (res.data.result == 0) {
              this.json = res.data.retVal;
            }
          });
      },

      clearData() {
        this.value = "";
        this.disValue = "";
        this.json = null;
      },
      input() {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.json = null;
        this.debounceTask = setTimeout(() => {
          this.searchData();
        }, 1000);

      },
      //下面都是黑色头部事件
      leftBack() {
        this.popupVisible = false;
      },
      gohome() {
        this.$router.push("/");
      },
      refresh() {
        location.reload();
      }
    },
    watch: {},
    created() {
    },
    components: {
      Popup,
      nothing
    }
  };
</script>

<style lang="less">
  .popSearch {
    float: right;

    .parent {
      position: relative;
      margin: 0 0.13333333rem;
      padding: 0 0.13333333rem;
      float: right;
      width: 6.76666667rem !important;
      box-sizing: border-box;
      height: 0.88rem;
      background: #fff;
      border: 1px solid #e8e8e8;

      .iconfont {
        position: absolute;
        right: 0.26666667rem;
        top: 0px;
      }

      .icon-xia {
        right: 0.15rem!important;
      }
    }

    .mint-popup-right {
      width: 100%;
      height: 100%;

      .topsHeader {
        z-index: 2000;
        position: fixed;
        height: 1.04rem;

        .mint-header {
          color: #fff;
          font-size: 16px;
          top: -1px;
          z-index: 100;
          padding: 0;

          .mint-header-button {
            padding: 0 0.2rem;

            .mintui-back {
              font-size: 0.7rem;
              line-height: 0.853333rem;
            }

            .mint-button {
              .mint-button-icon {
                float: right;
              }
            }
          }
        }
      }

      .autoSearch {
        position: fixed;
        top: 1.04rem;
        left: 0;
        z-index: 1000;
        width: 100%;
        background: #fff;
        height: 100%;

        .mint-searchbar {
          background: none;
          border-radius: 5px;
        }

        .mint-searchbar-inner {
          background: #efefef;
          border-radius: 1rem;
        }

        .mint-searchbar-core {
          text-indent: 0.3rem;
          background: #efefef;
          border: none !important;
        }

        .mintui-search {
          font-size: 0.5rem;
          margin-left: 0.2rem;
        }

        .mint-searchbar-cancel {
          color: #000;
        }

        .mint-cell-wrapper {
          font-size: 0.35rem;
          border-bottom: 1px solid #ccc;
          width: 90%;
          margin: 0 auto;
        }

        .mint-search-list {
          top: 8px;
          // .mint-search-list-warp {
          //   border-top: 5px solid #efefef;
          // }
        }

        .autoSearchTop {
          background-color: #fff;
          height: 1.666667rem;
        }

        .mint-search-list-warp .mint-cell:nth-of-type(1) .mint-cell-wrapper {
          background-image: none;
        }
      }
    }

    .autocomplete {
      position: fixed;
      top: 2.3rem;
      width: 100%;
      height: ~"calc(100% - 4rem)";
      box-sizing: border-box;
      overflow: hidden;
      padding-bottom: 2rem;

      ul {
        margin: 0 4px;
        height: 100%;
        overflow-y: scroll;

        .listBox {
          border-bottom: 2px solid #e8e8e8;
        }

        li {
          .iconfont {
            position: absolute;
            right: 15px;
            font-size: 0.34rem;
            top: 48%;
            color: #9b9b9b;
            z-index: 2;
          }
          a {
            .detail {
              width: 100%;
              line-height: 14px;
              font-size: 12px;
              background-color: #fff;
              border-bottom: none;

              .top {
                padding: 6px 8px;
                color: #000;
                border-bottom: 1px dashed #ddd;

                .left {
                  float: left;
                }

                .right {
                  float: right;

                  span {
                    color: #d0011b;
                  }
                }
              }

              .ct {
                overflow: hidden;

                .info {
                  color: #333;
                  float: left;
                  box-sizing: border-box;
                  height: auto;
                  line-height: 14px;
                  font-size: 12px;
                  overflow: hidden;
                  //   text-overflow: ellipsis;
                  //   white-space: nowrap;
                  word-wrap: break-word;
                }

                .info:nth-of-type(2n-1) {
                  width: 50%;
                  //   padding-left: 13px;
                }

                .info:nth-of-type(2n) {
                  width: 50%;
                }

              }
            }
          }
        }
      }
    }

    .transition,
    .autocomplete,
    .showAll-transition,
    .autocomplete ul,
    .autocomplete ul li a {
      transition: all 0.3s ease-out;
      -moz-transition: all 0.3s ease-out;
      -webkit-transition: all 0.3s ease-out;
      -o-transition: all 0.3s ease-out;
    }

    .autocomplete ul li a {
      text-decoration: none;
      display: block;
      color: #000;
      padding: 5px;
    }

    .autocomplete ul li a b {
      font-weight: normal;
    }

    .autocomplete ul li {
      width: 100%;
      background: #fff;
      position: relative;
      z-index: 1;
      height: auto;
      line-height: 21px;
      font-size: 12px;
    }

    .showAll-transition {
      opacity: 1;
      height: 50px;
      overflow: hidden;
    }

    .showAll-enter {
      opacity: 0.3;
      height: 0;
    }

    .showAll-leave {
      display: none;
    }

    .ph {
      color: #ccc;
    }
  }
</style>



// WEBPACK FOOTER //
// popSearch.vue?6ad58c61